import { Pipe, PipeTransform } from '@angular/core';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'tokenVaultStatusDisplay',
  standalone: true,
})
export class TokenVaultStatusDisplayPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    return CoreNiceLabelUtils.tokenVaultStatus(value);
  }
}
